/* @flow */

export {TimelineComments} from './timeline-comments';
export type {Props as TimelineCommentsProps} from './timeline-comments';
